/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientTargetModel } from '../../models/patient-target-model';

export interface GetPatientTargets$Params {
  patientID?: number;
  onlyActive?: boolean;
}

export function GetPatientTargets(http: HttpClient, rootUrl: string, params?: GetPatientTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientTargetModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientTargets.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientTargetModel>>;
    })
  );
}

GetPatientTargets.PATH = '/api/Supervisor/GetPatientTargets';
